import { render, staticRenderFns } from "./CompactHorizontal.vue?vue&type=template&id=5b0c8336"
import script from "./CompactHorizontal.vue?vue&type=script&lang=js"
export * from "./CompactHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports